import React, { Component } from 'react';
import copy from 'copy-to-clipboard';
// import IconButton from 'material-ui/IconButton';
// import CopyIcon from 'material-ui/svg-icons/content/content-copy';
import Snackbar from 'material-ui/Snackbar';

import theme from '../../../muiTheme';

class GuidCID extends Component {
  constructor(props) {
    super(props);

    this.state = {
      snackbarOpen: false
    };

    this.copyGuid = this.copyGuid.bind(this);
    this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
  }

  copyGuid() {
    this.setState({
      snackbarOpen: true
    });

    const { children } = this.props;

    const cleanGuid = children.substring(0, children.length).toUpperCase();
    copy(cleanGuid);
  }

  handleSnackbarClose() {
    this.setState({
      snackbarOpen: false
    });
  }

  // const getDisplay = function(text) {
  //   return text;// ? text.substring(1, 9) : '';
  // }

  render() {
    const { children } = this.props;

    if (!children) return null;

    const text = children
      .toUpperCase()
      .replace('{', '')
      .replace('}', '');

    /* eslint-disable */
    return (
      <div>
        <a title={'CID: The resource\'s unique qualification'} style={styles.text} onClick={this.copyGuid}>
          {text}
        </a>
        <Snackbar
          open={this.state.snackbarOpen}
          message="ID copied to clipboard."
          autoHideDuration={2000}
          onRequestClose={this.handleSnackbarClose}
        />
      </div>
    );
    /* eslint-enable */

    // return (
    //   <span title={text} style={styles.text}>{text}</span>
    // )

    // NOTE: Chuck/Kara would like to keep the full IrwinId
    // displayed for now, may revisit the idea of a copyable
    // Guid component at a later time.

    // return (
    //   <div style={styles.wrapper}>
    //     <div style={styles.contentContainer}>
    //       <span title={children} style={styles.text}>{getDisplay(children)}</span>
    //       <div style={styles.buttonContainer}>
    //         <IconButton
    //           style={styles.button}
    //           iconStyle={styles.icon}
    //           tooltip="Copy to clipboard"
    //           tooltipPosition="bottom-left"
    //           onClick={copyGuid}
    //         >
    //           <CopyIcon />
    //         </IconButton>
    //       </div>
    //     </div>
    //   </div>
    // )
  }
}

export default GuidCID;

const styles = {
  wrapper: {
    display: 'flex'
  },
  contentContainer: {
    border: '1px solid',
    borderColor: theme.palette.borderColor,
    borderRadius: theme.borderRadius,
    padding: '10px',
    display: 'flex'
  },
  text: {
    fontSize: '0.8em',
    cursor: 'copy'
  },
  button: {
    padding: '6px',
    width: '42px',
    height: '35px'
  },
  icon: {
    width: 18,
    height: 18
  },
  buttonContainer: {
    margin: '-10px -10px -10px 10px',
    borderLeft: '1px solid',
    borderColor: theme.palette.borderColor,
    background: '#f6f6f6'
  }
};



// WEBPACK FOOTER //
// ./src/components/common/GuidCID/GuidCID.js